import { jsx as _jsx } from "react/jsx-runtime";
import VersionItem from './VersionItem';
import { hasVisibleChanges } from './history-utils';
const SpeakerHistoryList = ({ history, selectedEntry, onSelectEntry }) => {
    var _a;
    const visibleEntries = (_a = history === null || history === void 0 ? void 0 : history.list.slice().reverse().filter(hasVisibleChanges)) !== null && _a !== void 0 ? _a : [];
    return (_jsx("div", { children: visibleEntries.map((entry) => (_jsx(VersionItem, { entry: entry, isSelected: (selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.timestamp) === entry.timestamp, onSelect: () => onSelectEntry(entry) }, `${entry.timestamp}-${entry.operation}`))) }));
};
export default SpeakerHistoryList;
